module.exports = __webpack_public_path__ + "static/media/m_y_45.f4fd78fc.png";